import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { colors } from "styles/colors";
import { deletePatientView } from "./savedViews";
import useSavedPatientViews from "./useSavedPatientViews";
import { PATIENTS_PATH } from "./usePatientTableState";

/** "My views" under Patients in the sidebar. Hidden until a view is saved. */
const SavedViewsNav = (): JSX.Element | null => {
  const views = useSavedPatientViews();
  const location = useLocation();
  if (!views.length) return null;

  const currentQuery = location.pathname === PATIENTS_PATH ? location.search : null;

  return (
    <Box sx={{ pl: 3, pb: 0.5 }}>
      <Typography sx={{ fontSize: 11, fontWeight: 700, color: colors.disabledGrey, textTransform: "uppercase", py: 0.5 }}>
        My views
      </Typography>
      {views.map((view) => (
        <Box
          key={view.id}
          sx={{
            display: "flex",
            alignItems: "center",
            borderRadius: 0.5,
            "&:hover": { backgroundColor: colors.lightGrey1 },
            "&:hover .delete-view, & .delete-view:focus-visible": { opacity: 1 },
          }}
        >
          <Link
            component={RouterLink}
            to={`${PATIENTS_PATH}${view.query}`}
            underline="none"
            title={view.title}
            sx={{
              flex: 1,
              minWidth: 0,
              py: 0.5,
              fontSize: 14,
              color: (theme) => theme.palette.text.primary,
              fontWeight: currentQuery === view.query ? "bold" : "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {view.title}
          </Link>
          <Tooltip title="Remove view">
            <IconButton
              className="delete-view"
              size="small"
              aria-label={`Remove saved view ${view.title}`}
              onClick={() => deletePatientView(view.id)}
              sx={{ opacity: 0, p: 0.25 }}
            >
              <CloseIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
};

export default SavedViewsNav;
